import React, { useEffect, useRef } from "react";

const ASSETS = "/images/affidea-day";
const ADMIN_TAP_WINDOW_MS = 1500;
const ADMIN_TAP_COUNT = 5;

interface EventHeaderProps {
  // Only the registration screen opens the admin menu, so players can't reach it mid-game.
  adminEnabled: boolean;
  onAdmin: () => void;
}

// Affidea Saúde + Affidea Day On Tour '26 logos; tap the Affidea logo 5× for the admin menu.
export default function EventHeader({ adminEnabled, onAdmin }: EventHeaderProps) {
  const tapCountRef = useRef(0);
  const tapTimeoutRef = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (tapTimeoutRef.current !== null) window.clearTimeout(tapTimeoutRef.current);
    },
    [],
  );

  const handleLogoTap = () => {
    if (!adminEnabled) return;
    tapCountRef.current += 1;
    if (tapTimeoutRef.current !== null) window.clearTimeout(tapTimeoutRef.current);
    tapTimeoutRef.current = window.setTimeout(() => {
      tapCountRef.current = 0;
    }, ADMIN_TAP_WINDOW_MS);
    if (tapCountRef.current >= ADMIN_TAP_COUNT) {
      tapCountRef.current = 0;
      onAdmin();
    }
  };

  return (
    <header className="ad-header">
      <img
        src={`${ASSETS}/affidea-saude.svg`}
        alt="Affidea Saúde"
        className="ad-logo"
        onClick={handleLogoTap}
      />
      <img
        src={`${ASSETS}/affidea-day-on-tour.png`}
        alt="Affidea Day On Tour '26"
        className="ad-event-logo"
      />
    </header>
  );
}
